'use client';

import { Modal, ModalBody, ModalContent } from '@nextui-org/react';
import { signIn } from 'next-auth/react';
import React from 'react';

import { GoogleSvg, LogoSymbolSvg } from '@/assets/svgs';
import { Button } from '@/components';
import { PermissionsRefresher } from '@/components/PermissionsRefresher';

interface AuthRecruiterContextType {
  openAuthRecruiter: () => void;
}

export const AuthRecruiterContext = React.createContext<AuthRecruiterContextType>({
  openAuthRecruiter: () => {},
});

export const useAuthRecruiterContext = () => React.useContext(AuthRecruiterContext);

interface AuthRecruiterProviderProps {
  children: React.ReactNode;
}

const AuthRecruiterProvider: React.FC<AuthRecruiterProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  const openAuthRecruiter = React.useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleSignIn = React.useCallback(async () => {
    const result = await signIn('google');
  }, []);

  const providerValue = React.useMemo(
    () => ({
      openAuthRecruiter,
    }),
    [openAuthRecruiter],
  );

  return (
    <>
      <AuthRecruiterContext.Provider value={providerValue}>
        {children}
      </AuthRecruiterContext.Provider>

      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalContent>
          <ModalBody className='flex items-center gap-8 p-6'>
            <LogoSymbolSvg height={40} />
            <div className='text-center space-y-3'>
              <div className='font-semibold text-2xl text-primary'>Sign in to KitesHR</div>
              <div className='text-text-tertiary-600'>
                Log in to start recruiting and receive rewards immediately
              </div>
            </div>
            <Button
              fullWidth={true}
              startContent={<GoogleSvg width={24} height={24} />}
              className='font-semibold text-primary'
              onClick={handleSignIn}
            >
              Continue with Google
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AuthRecruiterProvider;
